

import { createSlice } from "@reduxjs/toolkit";



export const currentUserDetail = createSlice({
  name: "currentUserDetail",
  initialState: {
    token: "",
    // userLoginName: "bharat sarda",
    // userLoginEmail: "ext-bharat.sarda@inizioadvisory.onmicrosoft.com",
    userLoginName: "",
    userLoginEmail: "",
    refreshToken: "",
    refreshTokenExp: "",
    user_id:"",
  },
  reducers: {
    getUserDataStart(state) {
      state.loading = true;
    },
    getUserDataSuccess(state, action) {
      state.loading = false;
      state.userInfo = action.payload;
    },
    getUserDataError(state) {
      state.loading = false;
    },
    resetUser(state) {
      state.userInfo = {};
    },
    setUserID:(state,action)=>{
      state.user_id=action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setUserLoginName: (state, action) => {
      state.userLoginName = action.payload;
    },
    setUserLoginEmail: (state, action) => {
      state.userLoginEmail = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    setRefreshTokenExp: (state, action) => {
      state.refreshTokenExp = action.payload;
    },
  },
});

export const {
  getUserDataStart,
  getUserDataSuccess,
  getUserDataError,
  resetUser,
  setToken,
  setUserLoginName,
  setUserLoginEmail,
  setRefreshToken,
  setRefreshTokenExp,
  setUserID,
} = currentUserDetail.actions;

export default currentUserDetail.reducer;
